import React from "react";
import ReactDOMServer from "react-dom/server";
import { IconCrossWhite, IconTrashRedBlur } from "@assets/img";
import Swal from "sweetalert2";
import "./index.css";

const CustomButton = ({ icon, text, className = "" }) => {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <div className="d-flex align-items-center" style={{ marginRight: 7 }}>
        <img src={icon} alt="icon" width={18} height={18} />
      </div>
      <div>
        <span>{text}</span>
      </div>
    </div>
  );
};

export const SuccessPopup = async (message) => {
  Swal.fire({
    title: "Success!",
    text: message || "Data Has Been Saved!",
    icon: "success",
    timer: 2000,
    timerProgressBar: true,
  });
};

export const ErrorPopup = async (message) => {
  Swal.fire({
    icon: "error",
    title: "Something went wrong!",
    text: message || "",
  });
};

export const InfoPopup = async (message) => {
  Swal.fire({
    icon: "info",
    title: "Information",
    text: message || "",
  });
};

export const DeletePopup = async (DeleteData) => {
  const cancelButton = ReactDOMServer.renderToString(
    <CustomButton icon={IconCrossWhite} text={"Cancel"} />
  );
  const deleteButton = ReactDOMServer.renderToString(
    <CustomButton icon={IconTrashRedBlur} text={"Delete"} />
  );
  await Swal.fire({
    html: "<p style = 'font-size:15px'>Do you want to delete data ?</p>",
    icon: "warning",
    customClass: {
      cancelButton: "btn btn btn-dark-gray mr-1",
      confirmButton: "btn btn btn-red-blur-outline",
    },
    buttonsStyling: false,
    showCancelButton: true,
    confirmButtonText: deleteButton,
    cancelButtonText: cancelButton,
    reverseButtons: true,
  }).then(async (res) => {
    if (res.isConfirmed) {
      await DeleteData();
    } else if (res.isDenied) {
      Swal.fire("Deletion is Canceled", "", "error");
    }
  });
};

export const ValidatePopup = async (message, validation) => {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    html: `<div><p>${
      message || "Some field cannot be empty"
    }</p><p>${validation}</p></div>`,
  });
};
